import React, { RefObject, useEffect, useRef, useState } from "react";
import "./style.css";
import { useLoading } from "../../context/LoadingContext";

// -----------------------------------------------------------------------

const Cursor = () => {
  const cursorRef: RefObject<HTMLDivElement> = useRef(null);
  const [hovering, setHovering] = useState<boolean>(false);
  const { loading } = useLoading();

  const isMacOS = navigator.userAgent.indexOf("Mac OS X") !== -1;

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (cursorRef.current && !loading) {
        cursorRef.current.style.left = `${e.clientX}px`;
        cursorRef.current.style.top = `${e.clientY}px`;
      }
    };

    const handleMouseEnter = () => !loading && setHovering(true);
    const handleMouseLeave = () => !loading && setHovering(false);

    const addEventListeners = () => {
      document.querySelectorAll("button, a").forEach((el) => {
        el.addEventListener("mouseenter", handleMouseEnter);
        el.addEventListener("mouseleave", handleMouseLeave);
      });
    };

    const removeEventListeners = () => {
      document.querySelectorAll("button, a").forEach((el) => {
        el.removeEventListener("mouseenter", handleMouseEnter);
        el.removeEventListener("mouseleave", handleMouseLeave);
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    addEventListeners();

    const observer = new MutationObserver(() => {
      removeEventListeners();
      addEventListeners();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      removeEventListeners();
      observer.disconnect();
    };
  }, [loading]);

  return (
    <div
      className="appCursor"
      ref={cursorRef}
      style={{
        width: hovering ? "50px" : "30px",
        height: hovering ? "50px" : "30px",
        transition: isMacOS ? "none" : "all 50ms ease-in-out",
      }}
    />
  );
};
export default Cursor;
